import React from "react";
import PartyPage from "./PartyPage";

export default function CustomersPage() {
  return <PartyPage kind="customer" />;
}
